import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

interface HeroSlide {
  id: string;
  image: string;
  tag: string;
  title: string;
  desc: string;
}

const slides: HeroSlide[] = [
  {
    id: "chugui-2",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20for%20a%20premium%20urban%20emotional%20drama%2C%20city%20skyline%20at%20dusk%20with%20deep%20midnight%20blue%20tones%20and%20warm%20orange%20window%20lights%2C%20rain%20mist%2C%20dramatic%20atmospheric%20lighting%2C%20moody%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=cg-hero-01&orientation=landscape",
    tag: "第二季 · 热播中",
    title: "出轨的味道：暗涌",
    desc: "婚姻进入修复期，而一封匿名信将沈知微与顾延再度卷入更深的漩涡，所有平静都只是暗涌。",
  },
  {
    id: "chugui-1",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20rainy%20city%20street%20at%20night%2C%20deep%20midnight%20blue%20palette%20with%20warm%20orange%20streetlight%20reflections%20on%20wet%20pavement%2C%20lonely%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=cg-hero-02&orientation=landscape",
    tag: "全剧集 · 已完结",
    title: "出轨的味道",
    desc: "一场看似完美的婚姻在雨夜裂开缝隙，沈知微循着一缕陌生的香气，走回了自己。",
  },
  {
    id: "chugui-3",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20an%20autumn%20university%20campus%20at%20golden%20hour%2C%20warm%20orange%20leaves%20against%20deep%20navy%20shadows%2C%20nostalgic%20melancholic%20mood%2C%20soft%20cinematic%20lighting%2C%20elegant%20atmospheric%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=cg-hero-03&orientation=landscape",
    tag: "特别篇 · 即将上线",
    title: "出轨的味道：归途",
    desc: "回到故事的最初，讲述顾延与沈知微初遇的十年前，那个改变两人一生的秋天。",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const touchStartX = useRef(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const go = (next: number) => setIndex((next + slides.length) % slides.length);

  const active = slides[index];

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="relative h-[440px] w-full md:h-[580px]">
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${i === index ? "opacity-100" : "opacity-0"}`}
          >
            <img
              src={slide.image}
              alt={`${slide.title} 焦点海报`}
              title={`${slide.title} 影视资讯`}
              className={`h-full w-full object-top ${i === index ? "animate-slow-zoom" : ""}`}
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-transparent to-primary-950/30"></div>

        <div
          className="absolute inset-0 flex items-center"
          onTouchStart={(event) => {
            touchStartX.current = event.touches[0].clientX;
          }}
          onTouchEnd={(event) => {
            const delta = event.changedTouches[0].clientX - touchStartX.current;
            if (delta > 50) go(index - 1);
            if (delta < -50) go(index + 1);
          }}
        >
          <div className="w-full px-4 pb-16 pt-10 md:px-10 md:pb-20">
            <div key={active.id} className="max-w-2xl animate-fade-up">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1.5 font-label text-[11px] tracking-wide text-primary-950">
                <i className="ri-fire-fill"></i>
                {active.tag}
              </span>
              <h1 className="mt-5 font-heading text-4xl font-bold leading-tight text-background-50 md:text-5xl lg:text-6xl">
                {active.title}
              </h1>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-50/80 md:text-base">{active.desc}</p>
              <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Link
                  to={`/detail/${active.id}`}
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-primary-950 transition-colors hover:bg-accent-400 cursor-pointer"
                >
                  <i className="ri-play-fill text-lg"></i>
                  查看剧情详情
                </Link>
                <Link
                  to="/category"
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer"
                >
                  <i className="ri-film-line text-lg"></i>
                  浏览全部剧集
                </Link>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(index - 1)}
          className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/50 text-background-50 transition-colors hover:bg-accent-500 hover:text-primary-950 md:flex cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(index + 1)}
          className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/50 text-background-50 transition-colors hover:bg-accent-500 hover:text-primary-950 md:flex cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        <div className="absolute bottom-6 left-4 flex items-center gap-2 md:left-10">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第${i + 1}张`}
              onClick={() => go(i)}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                i === index ? "w-8 bg-accent-500" : "w-4 bg-background-50/40 hover:bg-background-50/70"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}